import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";
const projectModuleAPI = createApi({
       reducerPath:"projectModueleAPI",
       baseQuery:customFetchBase,
       endpoints:(builder)=>({

        
        getProjectModuleByProjectId: builder.query({
            query: (ProjectId) => ({
                url: `/ProjectDetailsManagement/GetProjectModuleByProjectId?projectId=${ProjectId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllProjectModule: builder.query({
            query: () => ({
                url: `/ProjectDetailsManagement/GetAllProjectModule`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getProjectModuelList:builder.mutation({
            query:(data)=>({
                url:"ProjectDetailsManagement/GetProjectModuleByProjectIdList",
                method:"POST",
                body:transformRequest(data)
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse,
        }),
        addProjectModuel: builder.mutation({
            query:(data) => ({
                url: `/ProjectDetailsManagement/AddProjectModule`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteProjectModuel:builder.mutation({
            query:(projectModuleId)=>({
                url:`/ProjectDetailsManagement/DeleteProjectModule?id=${projectModuleId}`,
                method:'DELETE',
                body:transformRequest(projectModuleId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        getProjectModuelById: builder.query({
            query: (projectModuleId) => ({
                url: `/ProjectDetailsManagement/GetProjectModuleDetailsByID/?id=${Number(projectModuleId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProjectModuel: builder.mutation({
            query: (data) => ({
                url: '/ProjectDetailsManagement/UpdateProjectModule',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
       })
})

export const {
    useLazyGetProjectModuleByProjectIdQuery,
    useLazyGetAllProjectModuleQuery,
    useGetProjectModuelListMutation,
    useAddProjectModuelMutation,
    useDeleteProjectModuelMutation,
    useLazyGetProjectModuelByIdQuery,
    useUpdateProjectModuelMutation
    } = projectModuleAPI;

    export default projectModuleAPI;
